import { createEnumMap } from 'Commons/helpers/utils/Formatter';

const FILE_UPLOAD_STATUS = createEnumMap(['Loading', 'Error', 'Success']);

export { FILE_UPLOAD_STATUS };
